import { DEFAULT_OPT_IN_VALUES } from './CONSENT_SOURCE_TYPES';

const INVALID_VALUES = 'Use comma-separated values or a JSON array of strings, such as ["true"] or [].';

export function parseOptInValues(rawValue) {
  const value = rawValue?.trim() || DEFAULT_OPT_IN_VALUES;
  if (value.startsWith('[')) {
    let parsed;
    try {
      parsed = JSON.parse(value);
    } catch {
      throw new Error(INVALID_VALUES);
    }
    if (!Array.isArray(parsed) || !parsed.every(item => typeof item === 'string')) {
      throw new Error(INVALID_VALUES);
    }
    return parsed;
  }
  const parsed = value
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
  return parsed.length ? parsed : DEFAULT_OPT_IN_VALUES.split(',').map(item => item.trim());
}

export function formatOptInValues(values) {
  // JSON preserves empty mappings and literal delimiters that the shorthand would lose.
  if (
    !values.length ||
    values.some(value => !value || value !== value.trim() || value.includes(',') || value.includes('['))
  ) {
    return JSON.stringify(values);
  }
  return values.join(', ');
}

export function validateOptInValues(value) {
  try {
    parseOptInValues(value);
    return null;
  } catch (error) {
    return error.message;
  }
}
